import React, { useContext } from 'react';
import { Modal as ModalSUI, ModalBody, ModalHeader, } from '@one-thd/sui-atomic-components';
import { NationalAccountContext } from '../../../../../contexts';
export var Modal = function (_a) {
    var title = _a.title, children = _a.children;
    var _b = useContext(NationalAccountContext), showModal = _b.showModal, setShowModal = _b.setShowModal;
    var handleClose = function () {
        setShowModal(false);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalSUI, { open: showModal, onClose: handleClose },
            React.createElement(ModalHeader, { onClose: handleClose }, title),
            React.createElement(ModalBody, null, children))));
};
